<span class="flex justify-content-center tab-subtext pt-5 mb-6">
  {{ "CREATE_ORDER.COMMENTS.HEADER" | translate }}
</span>
<div class="comments-list-container">
  <p-scrollpanel [style]="{ width: '100%', 'min-height': '300px', 'max-height': '350px' }">
    <div class="flex flex-column gap-3 p-2">
      @for (comment of comments(); track comment.id; let i = $index) {
        @if (user()?.email === comment.createdByIdentifier) {
          <!-- Own comment - aligned right, yellow -->
          <div class="flex flex-column align-items-end" [class.opacity-50]="!includeComments[i]">
            <div class="flex align-items-center gap-2">
              <div class="comment-bubble comment-bubble-own">
                {{ comment.text }}
              </div>
              <p-checkbox [binary]="true" [ngModel]="includeComments[i]" (onChange)="onIncludeCommentChange($event, i)"></p-checkbox>
            </div>
            <div class="comment-info mr-1">
              @if (comment.createdByName) {
                {{ comment.createdByName }} •
              }
              {{ comment.created | relativeTime }}
            </div>
          </div>
        } @else {
          <!-- Other's comment - aligned left, black -->
          <div class="flex flex-column align-items-start" [class.opacity-50]="!includeComments[i]">
            <div class="flex align-items-center gap-2">
              <p-checkbox [binary]="true" [ngModel]="includeComments[i]" (onChange)="onIncludeCommentChange($event, i)"></p-checkbox>
              <div class="comment-bubble comment-bubble-other">
                {{ comment.text }}
              </div>
            </div>
            <div class="comment-info ml-1">
              @if (comment.createdByName) {
                {{ comment.createdByName }} •
              }
              {{ comment.created | relativeTime }}
            </div>
          </div>
        }
      }
    </div>
  </p-scrollpanel>
</div>
